import React, { Component } from 'react';
import { Row, Card, CardTitle } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../app/common/customBootstrap';
import './error.style.css';
import IntlMessage from '../../helpers/intlMessage';

class Error extends Component {
  render() {

    return (
      <div className='mv-error-page'>
        <div className='fixed-background' />
        <main>
          <div className='container'>
            <Row className='h-100'>
              <Colxx xxs='12' md='10' className='mx-auto my-auto'>
                <Card className='error-card'>
                  <div className='position-relative image-side '>
                    <p className='text-white h2 cshadow'>{this.props.title}</p>
                    <p className='white mb-0'>
                      <b>Descrição:</b> {this.props.desc}
                    </p>
                   {this.props.origin && <p className='white mb-0'>
                      <b>Origem:</b> {this.props.origin}
                    </p>}
                  </div>
                  <div className='form-side'>
                    <NavLink to='/' className='white'>
                      <span className='logo-single' />
                    </NavLink>
                    <CardTitle className='mb-4'>
                      <IntlMessage id='pages.error.title'/>
                    </CardTitle>
                    <p className='mb-0 text-muted text-small mb-0'>
                      <IntlMessage id='pages.error.code' />
                    </p>
                    <p className='display-1 font-weight-bold mb-5'>
                      Código: {this.props.code}
                    </p>
                    <NavLink
                      to={'/'}
                      className='btn btn-primary btn-shadow btn-lg'
                    >
                      <IntlMessage id='pages.error.gobackhome'/>
                    </NavLink>
                  </div>
                </Card>
              </Colxx>
            </Row>
          </div>
        </main>
      </div>
    );
  }
}

export default (Error);



// WEBPACK FOOTER //
// ./src/pages/error/error.page.js